export const SimpleLearnerDashboard = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;
